interface GenderFilters {
  [key: string]: string[];
}

export const genderFilters: GenderFilters = {
  Male: ['Male', 'M'],
  Female: ['Female', 'F'],
  'Non-binary': ['Non-binary', 'NB'],
};
